import SendIcon from "@material-ui/icons/Send"
import React from "react"
import values from "~/const.scss"

const CustomSendIcon = () => <SendIcon style={{ color: values.darkPurple }} />

export default CustomSendIcon
